module.exports = __webpack_public_path__ + "img/muzambinho.27694d9a.png";